export default {
    firstToCreate: 'Ole ensimmäinen, joka luo keskustelun tähän foorumiin',
    firstToPostInCategory: 'Ole ensimmäinen, joka julkaisee tässä kategoriassa',
    firstToRespondToTopic: 'Ole ensimmäinen, joka vastaa tähän aiheeseen!',
    createNewThread: 'Luo uusi keskustelu',
    thread: 'keskustelu',
    viewThread: 'Näytä keskustelu',
    replies: 'Vastaukset',
    noReplies: 'Ei vastauksia',
    reply: 'vastaus',
    _reply: 'Vastaa',
    ReplyTo: 'Vastaa',
    replyToThisQuestion: 'Vastaa tähän kysymykseen',
    onceRepliedModeratorMayRespond: 'Kun olet vastannut, foorumin moderaattori voi vastata vastaukseesi',
    onceRepliedCanViewResponses: 'Kun olet vastannut, voit nähdä muiden osallistujien vastaukset',
    loadingResponses: 'Ladataan vastauksia',
    hideXReplies: 'Piilota {count} vastausta',
    showXReplies: 'Näytä {count} vastausta',
    hideMostRecentReplies: 'Piilota uusimmat vastaukset',
    showMostRecentReplies: 'Näytä uusimmat vastaukset',
    post: 'Julkaise',
    message: 'Viesti',
    typeMessage: 'Kirjoita viesti',
    addPost: 'Lisää julkaisu',
    addMessage: 'Lisää viesti',
    editPost: 'Muokkaa julkaisua',
    editPostWithMedia: 'Muokkaa julkaisua medialla',
    createPostWithMedia: 'Luo julkaisu medialla',
    deleteMessage: 'Poista viesti',
    deleteMessageConfirm: 'Oletko varma, että haluat poistaa tämän viestin',
    pinPost: 'Kiinnitä julkaisu',
    media: 'Media',
    uploadMedia: 'Lataa media',
    categories: 'kategoriat',
    goBack: 'Palaa takaisin',
    goBackPrevious: 'Palaa edelliselle sivulle',
    goBackToCategory: 'Palaa {name} -kategoriaan',
    loadingLatestThreads: 'Ladataan viimeisimpiä keskusteluja',
    loadingDiscussionForum: 'Ladataan keskustelufoorumia',
    dontShowAgainForTask: 'Älä näytä uudelleen tälle tehtävälle',
    title: 'Otsikko',
    beTheFirst: 'Ole ensimmäinen, joka vastaa tähän ketjuun'
};
